const Footer = () => {
  return (
    <footer className="footer bg-info text-center py-3">
      <div className="container">
        <div className="copyright">
          <p className="mb-0">
            Copyright ©️ <i className="fa-solid fa-heart"></i> 444{' '}
            <i className="fa-solid fa-heart"></i>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;  